import { useState } from "react";
import { Field } from "../../components/neu/Field";
import { translateText } from "../../api/ai";

const TA = "w-full rounded-2xl bg-background px-3 py-2.5 text-sm shadow-neu-sm";

// العنوان والنص ثنائيا اللغة: اكتب بأي لغة ويُترجَم تلقائياً للأخرى عبر الذكاء الاصطناعي (Gemini).
export const NotifyComposer = ({ form, set }) => {
  const [busy, setBusy] = useState("");
  const tr = async (src, target, dest) => {
    const text = (form[src] || "").trim();
    if (!text) return;
    setBusy(dest);
    try {
      const out = await translateText(text, target);
      if (out) set(dest, out);
    } finally {
      setBusy("");
    }
  };
  const ai = (k) => (busy === k ? <span className="text-[10px] font-bold text-primary animate-pulse"> AI…</span> : null);
  return (
    <div className="grid gap-3">
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="العنوان (عربي)" testId="notify-title-ar" accent="sky" value={form.title_ar}
          onChange={(v) => set("title_ar", v)} autoLang="ar" onAuto={(v) => set("title_en", v)} dir="rtl" />
        <Field label="Title (English)" testId="notify-title-en" accent="violet" value={form.title_en}
          onChange={(v) => set("title_en", v)} autoLang="en" onAuto={(v) => set("title_ar", v)} dir="ltr" />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <p className="label-xs mb-2 text-emerald-500">النص (عربي){ai("body_ar")}</p>
          <textarea data-testid="notify-body-ar" dir="rtl" rows={3} className={TA} value={form.body_ar}
            onChange={(e) => set("body_ar", e.target.value)} onBlur={() => tr("body_ar", "en", "body_en")} />
        </div>
        <div>
          <p className="label-xs mb-2 text-amber-500">Body (English){ai("body_en")}</p>
          <textarea data-testid="notify-body-en" dir="ltr" rows={3} className={TA} value={form.body_en}
            onChange={(e) => set("body_en", e.target.value)} onBlur={() => tr("body_en", "ar", "body_ar")} />
        </div>
      </div>
    </div>
  );
};
